import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import './ContatosPage.css';

function ContatosPage() {
  const cardRef = useRef(null);
  const formSecRef = useRef(null);
  const [formData, setFormData] = useState({
    nome: '', empresa: '', email: '', telefone: '',
    cidade: '', assunto: '', mensagem: '',
  });
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    
    // Dispara evento formstart na primeira interação
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        'event': 'formstart',
        'event_category': 'form',
        'event_label': 'contact_page_form',
        'form_name': 'ContatosPageForm'
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setErro('');
    try {
      const apiUrl = window.MSA_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:3001/api/contato';
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (res.ok) {
        setEnviado(true);
        
        // Envia evento de conversão para GTM
        if (typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer.push({
            'event': 'form_submit',
            'event_category': 'form',
            'event_label': 'contact_page_form_success',
            'form_name': 'ContatosPageForm'
          });
        }
        
        // Redirect automático para WhatsApp após 2 segundos
        setTimeout(() => {
          const whatsappNumber = '5562991563162';
          const message = encodeURIComponent('Olá! Acabei de enviar uma mensagem pelo formulário de contato.');
          window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
        }, 2000);
      } else {
        setErro(data.erro || 'Erro ao enviar. Tente novamente.');
      }
    } catch {
      setErro('Não foi possível conectar ao servidor. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ct__visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (cardRef.current) observer.observe(cardRef.current);
    if (formSecRef.current) observer.observe(formSecRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div>
      {/* Seção mapa */}
      <section className="ct-map">
        <iframe
          className="ct-map__iframe"
          title="MSA Porta Paletes - Localização"
          src="https://maps.google.com/maps?q=Av.+Contorno,+Jardim+Arco+Verde,+An%C3%A1polis+-+GO,+75133-770&t=&z=15&ie=UTF8&iwloc=B&output=embed"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />

        {/* Card sobreposto */}
        <div className="ct-card ct__fade" ref={cardRef}>
          <h1 className="ct-card__title">Fale Conosco</h1>
          <p className="ct-card__desc">
            Estamos estrategicamente localizados em Anápolis, um dos principais polos logísticos do
            Centro-Oeste, o que nos permite oferecer agilidade no atendimento e facilidade no acesso
            para nossos clientes. Em um ponto de fácil localização, ideal para visitas, retirada de
            produtos e atendimento personalizado.
          </p>

          <ul className="ct-card__infos">
            <li>
              <span className="ct-card__label">Endereço</span>
              <span className="ct-card__value">
                Av. Contorno - Jardim Arco Verde, São João<br />
                Anápolis - GO, 75133-770
              </span>
            </li>
            <li>
              <span className="ct-card__label">Telefones</span>
              <span className="ct-card__value">
                (62) 99156-3162<br />(62) 3842-0082
              </span>
            </li>
            <li>
              <span className="ct-card__label">E-mail</span>
              <span className="ct-card__value">wagner@msaportapaletes.com.br</span>
            </li>
          </ul>

          <a
            className="ct-card__btn"
            href="https://share.google/wZi0aebFZSEjhG2yF"
            target="_blank"
            rel="noopener noreferrer"
          >
            Como Chegar
          </a>
        </div>
      </section>

      {/* Seção informações de contato */}
      <section className="ct-form-section ct__fade" ref={formSecRef}>
        <div className="ct-form-section__inner">

          {/* Lado esquerdo */}
          <div className="ct-left">
            <h2 className="ct-left__title">CONTATO</h2>
            <p className="ct-left__desc">
              Entre em contato com nossa equipe técnica para orçamentos e
              consultoria estratégica em soluções de armazenagem industrial.
            </p>

            <ul className="ct-left__list">
              <li className="ct-left__item">
                <div className="ct-left__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                  </svg>
                </div>
                <div>
                  <span className="ct-left__label">TELEFONE</span>
                  <p className="ct-left__value">(62) 99156-3162</p>
                  <p className="ct-left__value">(62) 3842-0082</p>
                </div>
              </li>

              <li className="ct-left__item">
                <div className="ct-left__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <div>
                  <span className="ct-left__label">E-MAIL</span>
                  <p className="ct-left__value">contato@msaportapaletes.com.br</p>
                </div>
              </li>

              <li className="ct-left__item">
                <div className="ct-left__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <div>
                  <span className="ct-left__label">LOCALIZAÇÃO</span>
                  <p className="ct-left__value">AV. CONTORNO, QD 05 LOTE 03/04, SÃO</p>
                  <p className="ct-left__value">JOÃO, ANÁPOLIS - GO</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Lado direito — formulário */}
          <div className="ct-form-wrap">
            <h3 className="ct-form__title">Fale com a MSA Porta Paletes</h3>

            {enviado ? (
              <p className="ct-form__sucesso">
                Mensagem enviada! Nossa equipe retornará em até 24 horas úteis.
              </p>
            ) : (
              <form className="ct-form" onSubmit={handleSubmit}>
                <div className="ct-form__row">
                  <div className="ct-form__field">
                    <label className="ct-form__label">Nome completo *</label>
                    <input className="ct-form__input" name="nome" required value={formData.nome} onChange={handleChange} />
                  </div>
                  <div className="ct-form__field">
                    <label className="ct-form__label">Empresa</label>
                    <input className="ct-form__input" name="empresa" value={formData.empresa} onChange={handleChange} />
                  </div>
                </div>

                <div className="ct-form__row">
                  <div className="ct-form__field">
                    <label className="ct-form__label">E-mail corporativo *</label>
                    <input className="ct-form__input" name="email" type="email" required value={formData.email} onChange={handleChange} />
                  </div>
                  <div className="ct-form__field">
                    <label className="ct-form__label">Telefone com DDD</label>
                    <input className="ct-form__input" name="telefone" value={formData.telefone} onChange={handleChange} />
                  </div>
                </div>

                <div className="ct-form__row">
                  <div className="ct-form__field ct-form__field--full">
                    <label className="ct-form__label">Cidade/Estado</label>
                    <input className="ct-form__input" name="cidade" value={formData.cidade} onChange={handleChange} />
                  </div>
                </div>

                <div className="ct-form__row">
                  <div className="ct-form__field ct-form__field--full">
                    <label className="ct-form__label">Assunto *</label>
                    <select className="ct-form__input ct-form__select" name="assunto" required value={formData.assunto} onChange={handleChange}>
                      <option value=""></option>
                      <option>Orçamento</option>
                      <option>Dúvida técnica</option>
                      <option>Parceria</option>
                      <option>Outro</option>
                    </select>
                  </div>
                </div>

                <div className="ct-form__row">
                  <div className="ct-form__field ct-form__field--full">
                    <label className="ct-form__label">Mensagem *</label>
                    <textarea className="ct-form__input ct-form__textarea" name="mensagem" required rows={5} value={formData.mensagem} onChange={handleChange} />
                  </div>
                </div>

                <button type="submit" className="ct-form__btn" disabled={enviando}>
                  {enviando ? 'Enviando...' : 'Enviar Mensagem'}
                </button>

                {erro && <p className="ct-form__erro">{erro}</p>}

                <p className="ct-form__nota">
                  Nossa equipe técnica e comercial retornará em até{' '}
                  <span className="ct-form__nota--destaque">24 horas úteis</span>.
                </p>
              </form>
            )}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ContatosPage;
